import { ConfigExample } from './index';

/**
 * An example Ergogen configuration for the Alpha keyboard layout.
 * This example demonstrates a staggered bottom row.
 * @type {ConfigExample}
 */
const Alpha: ConfigExample = {
  label: 'Alpha (staggered bottom row)',
  author: 'jcmkk3',
  value: `points:
  mirror:
    ref: ortho_inner_home
    distance: 1U
  zones:
    ortho:
      columns:
        pinky:
        ring:
        middle:
        index:
        inner:
      rows:
        home.padding: 1U
        top.padding: 1U
    stagger:
      anchor:
        ref: ortho_pinky_home
        shift: [0.5U, -1U]
      columns:
        pinky:
        ring:
        middle:
        index:
          key.asym: left
        space:
          key:
            spread: 0.5U
            asym: right
            width: 2*(u-1)
      rows:
        bottom.padding: 1U
`,
};

export default Alpha;
